<template>
    <b-modal title="Agenda Box" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" ref="mdlConfigurazioneAgendaBox" scrollable @show="onShow" @ok="onOk" @cancel="onClickCloseModal">
        <!-- @ok="onClickSavePostoLetto" ok-title="Salva" -->
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Nome</label>
                <b-form-input v-model="jsonData.nome"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonData.note" placeholder="" rows="5"></b-form-textarea>
            </b-col>
        </b-row>
        <!--    <template #modal-footer>
            <b-button @click="onClickCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button v-if="isTrasferimentoPaziente" @click="onClickSavePostoLettoTrasferimento" variant="outline-success" size="md">Salva</b-button>
            <b-button v-else @click="onClickSavePostoLetto" variant="outline-success" size="md">Salva</b-button>
        </template> -->
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    name: "RsaAssegnaPostoLettoModalEditComponent",
    mixins: [UtilityMixin],
    components: {},
    props: {},
    computed: {},
    data() {
        return {
            pathResource: "/agendebox",
            title: null,
            id: "",
            jsonData: { nome: "", note: "" },
        };
    },
    watch: {},
    methods: {
        show() {
            let me = this;
            me.jsonData = { nome: "", note: "" };
            me.$refs.mdlConfigurazioneAgendaBox.show();
        },
        edit(id) {
            let me = this;
            me.id = id;
            me.$refs.mdlConfigurazioneAgendaBox.show();
        },
        onClickCloseModal() {
            let me = this;
            me.id = null;
            me.jsonData = { nome: "", note: "" };
        },
        onOk(bvModalEvent) {
            let me = this;
            bvModalEvent.preventDefault();
            me.saveResource(me.pathResource, me.jsonData, me.saveAgendaBox, me.saveErrorAgendaBox);
        },
        saveAgendaBox() {
            let me = this;
            me.jsonData = { nome: "", note: "" };
            me.$refs.mdlConfigurazioneAgendaBox.hide();
            me.$emit("afterSave");
            me.$bvToast.toast("Ricovero avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveErrorAgendaBox(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore nel salvattaggio";
            me.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onShow() {
            let me = this;
            if (me.id) {
                me.loadData();
            } else {
                me.jsonData = { nome: "", note: "" };
            }
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.resultResponseLoadData, me.resultErrorLoadData);
        },
        resultResponseLoadData(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        resultErrorLoadData(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                autoHideDelay: 5000,
                variant: "danger",
            });
        },
    },
};
</script>

<style></style>
